import { Navigate } from "react-router-dom";

function RequireFlow({ sessionKeys, redirectTo, children }) {
  const hasFlowState = sessionKeys.every((key) => sessionStorage.getItem(key));
  if (!hasFlowState) {
    return <Navigate to={redirectTo} replace />;
  }
  return children;
}

export default RequireFlow;
